(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["isr-kit-details"] && !Shopify.designMode) return;
  try {
    
class ISRKitCustomizer extends HTMLElement {
 connectedCallback() {
  if (this.initialized) return;
  this.initialized = true;
  this.money = new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'});
  this.addEventListener('change', () => this.update());
  this.querySelector('[data-reset]').addEventListener('click', () => {
   this.querySelectorAll('select').forEach(select => select.selectedIndex = 0);
   this.querySelectorAll('[data-addon]').forEach(input => input.checked = false);
   this.update();
  });
  this.update();
 }
 update() {
  const base = Math.round(Number(this.dataset.base) * 100);
  const binder = this.querySelector('[data-binder]');
  const upgrade = Math.round(Number(binder.value) * 100);
  let total = base + upgrade;
  this.querySelector('[data-binder-label]').textContent = binder.selectedIndex === 0 ? '1.5-inch binder' : '3-inch binder upgrade';
  this.querySelector('[data-binder-cost]').textContent = upgrade ? '+' + this.money.format(upgrade / 100) : 'Included';
  const list = this.querySelector('[data-selected-addons]');
  list.replaceChildren();
  this.querySelectorAll('[data-addon]:checked, [data-upgrade]').forEach(input => {
   if (!Number(input.value)) return;
   const amount = Math.round(Number(input.value) * 100);
   total += amount;
   const li = document.createElement('li');
   li.className = 'isr-line';
   const name = document.createElement('span');
   name.textContent = input.dataset.name;
   const cost = document.createElement('span');
   cost.textContent = '+' + this.money.format(amount / 100);
   li.append(name, cost);
   list.append(li);
  });
  this.querySelector('[data-total]').textContent = this.money.format(total / 100);
 }
}
if (!customElements.get('isr-kit-customizer')) customElements.define('isr-kit-customizer', ISRKitCustomizer);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
